import React from 'react';
import { Range, Handle } from 'rc-slider';
import 'rc-slider/assets/index.css';
import '../PriceFilter/styles.css';

const handle = (props, minSize, maxSize) => {
  const { className, value, offset, index } = props;
  const left = className[className.length - 1] === '1';
  const diff = maxSize - minSize;
  return (
    <div key={index}>
      <Handle {...props} />
      <div
        className={`label ${left ? 'left' : 'right'}`}
        style={{
          left: diff > 100 ? `calc(-50px + ${(offset)}%)` : left ? `calc(-95px + ${(offset)}%)` : `${offset - 2}%`,
          textAlign: (left && diff <= 100) ? 'right' : (!left && diff <= 100) ? 'left' : '',
        }}
      >
        {value} <span>fm</span>
      </div>
    </div>
  );
};

handle.propTypes = {
  className: React.PropTypes.any,
  value: React.PropTypes.any,
  offset: React.PropTypes.any,
  index: React.PropTypes.any,
};

const SizeFilter = ({ minSize, maxSize, onMinMaxSizeChange }) => (
  <div className="interval-filter">
    <h2>Fermetrar</h2>
    <div className="slider-wrapper">
      <Range
        min={0}
        max={500}
        step={10}
        allowCross={false}
        value={[minSize, maxSize]}
        onChange={onMinMaxSizeChange}
        handle={props => handle(props, minSize, maxSize)}
      />
    </div>
    <div className="min-max-label">
      <span>0 fm</span>
      <span>500 fm +</span>
    </div>
  </div>
);

SizeFilter.propTypes = {
  minSize: React.PropTypes.number.isRequired,
  maxSize: React.PropTypes.number.isRequired,
  onMinMaxSizeChange: React.PropTypes.func.isRequired,
};

export default SizeFilter;



// WEBPACK FOOTER //
// ./src/browser/filters/SizeFilter/SizeFilter.js